import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type State = {
	uploadDocxFileModalCloseHandlers: {
		cancelInteraction: () => void;
		completeInteraction: () => void;
	};
};

type Actions = {
	setUploadDocxFileModalCloseHandlers: (
		value: State['uploadDocxFileModalCloseHandlers']
	) => void;
};

export type UploadDocxFileModalState = State & Actions;

const initialState = {
	uploadDocxFileModalCloseHandlers: null,
};

export const createUploadDocxFileModalSlice: StateCreator<
	UploadDocxFileModalState
> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		setUploadDocxFileModalCloseHandlers: value => {
			set({
				uploadDocxFileModalCloseHandlers: value,
			});
		},
	};
};
